import React, { useState, useEffect } from "react";

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import { Button, Col, Form, Table, Image, Modal, Row } from "react-bootstrap";
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import EditOpenIssuesVendor from "../../superAdminOpenIssuesVendor/InsideAllPageComponent/EditOpenIssuesVendor";
import { SuperAdminCall } from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import { TwilioCalling } from "../../../../reusableComponents/TwilioCalling";
import SuperAdminSMS from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import isEmpty from "../../../../../store/validation/is-Empty";
import AdminTwilioCallingPopup from "../../superAdminPendingVendors/AdminTwilioCallingPopup";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const BodyData = (props) => {
  const [show, setShow] = useState(false);
  const [pointOfContact, setPointOfContact] = useState();
  useEffect(() => {
    setPointOfContact(
      props.issue?.restaurant_id?.point_of_contact.filter(
        (vendor) => vendor.defaultChecked === true
      )
    );
  }, []);

  const onClickCustomData = (data) => {
    let finalVendor = data;
    let formData = {};
    formData.vendor = finalVendor && finalVendor;
    return formData;
  };

  return (
    <tbody key={props.index}>
      <tr
        className="super_admin_all_users_table_body super-admin-suggestion-table-body"
        onClick={() => setShow(!show)}
      >
        <td style={{ width: "8%" }}>
          <div className="f12-400">{props.issue?.issue_id}</div>
        </td>
        <td style={{ width: "18%" }}>
          <div className="super-admin-suggestion-table-body-boxone">
            <div className="super-admin-suggestion-imageBox mr-3">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    fluid
                    src={
                      props.issue &&
                      props.issue.restaurant_id &&
                      props.issue.restaurant_id.logo_url
                    }
                    alt="Icon"
                    title="Restaurant Picture"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
            <div className="super-admin-suggestion-imageBoxText pl-0">
              <div className="f14-500">
                {props.issue?.restaurant_id?.restaurant_name || ""}
              </div>
              <div className="f12-400">{props.issue?.issue_id}</div>
              <div className="f10-400">
                {props?.issue?.restaurant_id?.city || ""}
              </div>
            </div>
          </div>
        </td>
        <td style={{ width: "15%" }}>
          <div className="super-admin-suggestion-table-body-boxone">
            {/* <div className="super-admin-suggestion-imageBoxOne mr-3">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    fluid
                    src={
                      props.profile &&
                      props.profile[0] &&
                      props.profile[0].profile_Photo !== undefined &&
                      props.profile[0].profile_Photo !== null
                        ? props.profile &&
                          props.profile[0] &&
                          props.profile[0].profile_Photo
                        : require("../../../../../assets/images/ActionImages/demoprofile.jpg")
                    }
                    alt="Icon"
                    title="User Profile"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            </div> */}
            <div className="super-admin-suggestion-imageBoxTwo">
              <div className="f12-500">
                {props.issue?.createdBy?.name || ""}
              </div>
              <div className="f10-400">
                {props.issue?.createdBy?.role || ""}
              </div>
            </div>
          </div>
        </td>
        <td style={{ width: "12%" }}>
          <div className="f12-400">{props.issue?.issue_title || ""}</div>
        </td>
        <td style={{ width: "12%" }}>
          {props.issue?.category?.category_name || ""}
        </td>
        <td style={{ width: "15%" }}>{props.issue?.comment || ""}</td>
        <td style={{ width: "10%" }}>
          <div className="d-flex align-items-center">
            <div className="f12-400">
              {props.calcStatus(props.issue.status)}
            </div>
            <i
              className="ml-2 fa fa-angle-down"
              aria-hidden="true"
              onClick={() =>
                props.onShowModal(props.issue.status, props.issue._id)
              }
            ></i>
          </div>
        </td>
        <td style={{ width: "10%" }}>{props.issue?.type}</td>
      </tr>
      {show && (
        <React.Fragment>
          <tr
            className="mt-0 super-admin-suggestion-table-body"
            style={{
              borderTop: "1px solid #bfbfbf",
            }}
          >
            <td style={{ width: "14%" }}>
              <div className="f12-700">Actions</div>
              <div className="mt-2 d-flex align-items-center">
                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  onClick={props.sendInformationViewIssues(props.issue._id)}
                >
                  <Image
                    fluid
                    alt="View"
                    title="View"
                    src={require("../../../../../assets/images/UserManagement/eye.svg")}
                  />
                </Button>

                <EditOpenIssuesVendor
                  editData={props.issue}
                  actionBy="Issue"
                  appendSuggestionNew={props.appendSuggestionNew}
                  disabled={
                    // props.issue?.createdBy?.role === "SUPER ADMIN"
                    //   ?
                    false
                    // : true
                  }
                  category={props.category}
                  // issueDetail={props.issue}
                  // updateLatest={updateLatest}
                />
                {/* <EditUserOpenIssues /> */}
              </div>
            </td>
            <td style={{ width: "15%" }}>
              <div className="f12-700">Issue Date</div>
              <div className="f12-400 mt-2">
                {moment(props.issue && props.issue.createdAt).format("lll")}
              </div>
            </td>
            <td style={{ width: "12%" }}>
              <div className="f12-700">Uploaded Photos</div>
              <div className="mt-2">
                <div className="d-flex flex-wrap align-items-center">
                  {props?.issue?.attachment &&
                    props?.issue?.attachment.map((photos, index) => {
                      return (
                        <React.Fragment key={index}>
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              <div className="enIMG33 rounded-circle mr-2">
                                <Image
                                  fluid
                                  src={photos}
                                  alt="Icon"
                                  title="Issues Photo"
                                />
                              </div>
                            </SRLWrapper>
                          </SimpleReactLightbox>
                        </React.Fragment>
                      );
                    })}
                </div>
              </div>
            </td>
            <td style={{ width: "25%" }}>
              <div className="f12-700 mb-2">Point of Contact</div>
              {!isEmpty(pointOfContact) &&
                pointOfContact.map((singleitem, index) => {
                  return (
                    <React.Fragment key={index}>
                      {/* {console.log(singleitem)} */}
                      <div className="row">
                        <div className="col-7">
                          <div className="row">
                            <div className="col-4">
                              <SimpleReactLightbox>
                                <SRLWrapper options={options}>
                                  <div className="enIMG33 rounded-circle mr-2">
                                    <Image
                                      fluid
                                      src={singleitem?.profile_Photo}
                                      alt="Icon"
                                      title="Issues Photo"
                                    />
                                  </div>
                                </SRLWrapper>
                              </SimpleReactLightbox>
                            </div>
                            <div className="col-8">
                              <div className="f12-700">
                                {singleitem.firstName +
                                  " " +
                                  singleitem.lastName}
                              </div>
                              <div className="f11-400">
                                {singleitem?.selected_position}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-5">
                          {!isEmpty(singleitem.phone_numbers) &&
                            singleitem.phone_numbers.map((phone, index) => {
                              let number = {
                                country_code: phone?.country_code,
                                mobile_no: phone?.mobile_no,
                              };
                              let data = {
                                firstName: singleitem?.firstName,
                                lastName: singleitem.lastName,
                              };
                              return (
                                <React.Fragment key={index}>
                                  <div className="d-flex">
                                    <AdminTwilioCallingPopup
                                      allData={data}
                                      sendData={number}
                                    />
                                    <SuperAdminSMS
                                      dataSend={onClickCustomData(
                                        props?.issue?.vendor_id
                                      )}
                                    />
                                  </div>
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
            </td>
            {props.issue?.createdBy?.role === "SUPER ADMIN" && (
              <>
                <Divider orientation="vertical" flexItem />
                <td style={{ width: "15%" }}>
                  <div className="f12-700">Point of Contact</div>
                  <div className="f12-500">
                    {`${
                      props.issue?.restaurant_id?.point_of_contact[0]
                        ?.firstName || ""
                    } ${
                      props.issue?.restaurant_id?.point_of_contact[0]
                        ?.lastName || ""
                    }`}
                  </div>
                  <div className="f10-400">
                    {props.issue?.restaurant_id?.point_of_contact[0]
                      ?.selected_position || " "}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="mt-2 d-flex align-items-center">
                    {props.issue?.restaurant_id?.point_of_contact[0]
                      ?.phone_numbers[0]?.mobile_no && (
                      <TwilioCalling
                        user_name={`${
                          props.issue?.restaurant_id?.point_of_contact[0]
                            ?.firstName || ""
                        } ${
                          props.issue?.restaurant_id?.point_of_contact[0]
                            ?.lastName || ""
                        }`}
                        country_code={
                          props.issue?.restaurant_id?.point_of_contact[0]
                            ?.phone_numbers[0]?.country_code
                        }
                        mobile_number={
                          props.issue?.restaurant_id?.point_of_contact[0]
                            ?.phone_numbers[0]?.mobile_no
                        }
                      />
                    )}
                    <SuperAdminSMS dataSend={props?.issue?.vendor_id} />
                  </div>
                </td>
              </>
            )}
          </tr>
        </React.Fragment>
      )}
    </tbody>
  );
};
